import type { NotificationAsyncDelete } from "@/entities/notification";

export const getTitleTranslationKey = (
  notification: NotificationAsyncDelete
): string => {
  const { is_batch_processing, models } = notification.data;

  const modelType = models[0].type;
  const item = is_batch_processing ? `${modelType}s` : modelType;

  return `notification:asyncDelete.title.${item}`;
};
